export default{
    name: "Button",
    props: {
        href: {
            type: String
        },
        type: {
            type: String,
            default: 'primary'
        },
        target: {
            type: String
        },
        text: {
            type: String,
            required: true
        }
    }
}
